import React from 'react';
import he from "he";
import moment from 'moment';
import { useEffect, useState } from 'react';
import { momentLocalizer, Navigate, ToolbarProps } from 'react-big-calendar';
import { useFetchData } from '../utils/useFetchData';

const localizer = momentLocalizer(moment);

const EasyCalToolbar = (props: ToolbarProps) => {
  const [viewState, setViewState] = useState(props.view);

  useEffect(() => {
    setViewState(props.view);
  }, [props.view]);

  const onViewChange = (e) => {
    props.onView(e);
    setViewState(e);
  }
  const goToBack = () => {
    props.onNavigate(Navigate.PREVIOUS);
  };
  const goToNext = () => {
    props.onNavigate(Navigate.NEXT);
  };
  const goToToday = () => {
    props.onNavigate(Navigate.TODAY);
  };

  return (
    <div className="rbc-toolbar">
      {/* <img className="rbc-arrow-btn rbc-arrow-back" onClick={goToBack} /> */}
      <div className="rbc-arrow-btn rbc-arrow-back" onClick={goToBack}></div>
      <h1 className="rbc-toolbar-label">{moment(props.date).format('MMMM YYYY')}</h1>
      {/* <img className="rbc-arrow-btn rbc-arrow-next" onClick={goToNext} /> */}
      <div className="rbc-arrow-btn rbc-arrow-next" onClick={goToNext}></div>
    </div>
  );
};

export default EasyCalToolbar;